import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=54f86a2c&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=js&"
export * from "./Error404.vue?vue&type=script&lang=js&"
import style0 from "./Error404.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Error404.vue?vue&type=style&index=1&id=54f86a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f86a2c",
  null
  
)

export default component.exports